/* lazyload.js (c) Lorenzo Giuliani
 * MIT License (http://www.opensource.org/licenses/mit-license.html)
 *
 * expects a list of:
 * `<img src="blank.gif" data-src="my_image.png" width="600" height="400" class="lazy">`
 */
export class Overlay {
    init() {
        $(document).ready(function () {
            const loader = document.querySelector('.main-loader');
            const overlay = document.getElementById('body-overlay');

            if (loader) {
                loader.classList.add("main-loader-hidden");
            }

            if (overlay) {
                overlay.style.display = 'none';
            }
        });
    }
}